import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'


import {
    formataDataEmMesAnoSemBarra,
    calculaMeses,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import instituicaoFinanceiraList from '../../../business-rules/List/instituicaoFinanceiraList'

import {
    pesquisaList,
    pesquisaDescricaoList,
    pesquisaIndexList,
} from '../../../business-rules/List/ListService'

import {
    incrementaContFinanciamento,
    processaRegistrosDefaultIniciaisFinanciamento,
    calculaParcelaAdicional,
} from '../despesas-form/DespesasServiceFinanciamento'



export const processaCalculoConsorcioSimulacaoItem = (values, item, linhaInstituicaoFinanceira) => {

    if (
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAdemicon ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAncora ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraCNP ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraItau ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraUne ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraXP
    ) {

        item.valorTaxaAdministracao = round(item.valorCreditoConsorcio * item.taxaAdministracao / 100, 2)

        item.valorFundoReserva = round(item.valorCreditoConsorcio * item.percFundoReserva / 100, 2)

        item.taxaTotal =
            item.taxaAdministracao && (item.percFundoReserva || item.percFundoReserva === 0)
                ?
                    item.taxaAdministracao + item.percFundoReserva
                :
                    ''

        item.valorTaxaTotal = item.valorTaxaAdministracao + item.valorFundoReserva

        item.valorSaldoDevedor = round(item.valorCreditoConsorcio, 2) +
            item.valorTaxaAdministracao + item.valorFundoReserva

        if (item.pessoaFisicaJuridica === HARDCODE.idPessoaJuridica) {

            item.percSeguroPrestamista = ''
        }
        item.valorSeguroPrestamista = round(item.valorSaldoDevedor * item.percSeguroPrestamista / 100, 2)

        item.fatorRedutorParcela = item.percRedutorParcela ? 1 - (item.percRedutorParcela / 100) : ''

        item.valorParcelaInicialSemSeguroPrestamista =
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraAdemicon //||
            //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander
                ?
                    round(((round(item.valorCreditoConsorcio, 2) * (item.percRedutorParcela ? item.fatorRedutorParcela : 1)) +
                        item.valorTaxaAdministracao + /*//////item.valorFundoReserva*/
                            round(item.valorCreditoConsorcio * (item.percRedutorParcela && item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraSantander ? item.fatorRedutorParcela : 1) *
                                item.percFundoReserva / 100, 2)/* + item.valorTaxaAdesao*/) / item.prazoTotalGrupoConsorcio, 1)
                    //Embracon => Santander
                    //((round(item.valorCreditoConsorcio, 2) * (item.percRedutorParcela ? item.fatorRedutorParcela : 1)) +
                    //        item.valorTaxaAdministracao + /*//////item.valorFundoReserva*/
                    //            round(item.valorCreditoConsorcio * (item.percRedutorParcela ? item.fatorRedutorParcela : 1) *
                    //                item.percFundoReserva / 100, 2)/* + item.valorTaxaAdesao*/) / item.prazoTotalGrupoConsorcio
                :
                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander
                        ?
                            ((round(item.valorCreditoConsorcio, 2) * (item.percRedutorParcela ? item.fatorRedutorParcela : 1)) +
                                item.valorTaxaAdministracao + /*//////item.valorFundoReserva*/
                                    round(item.valorCreditoConsorcio * /*(item.percRedutorParcela ? item.fatorRedutorParcela : 1) **/
                                        item.percFundoReserva / 100, 2)/* + item.valorTaxaAdesao*/) / item.prazoTotalGrupoConsorcio
                        :
                            round((item.valorSaldoDevedor / item.prazoTotalGrupoConsorcio) *
                                (item.percRedutorParcela ? item.fatorRedutorParcela : 1), 2)

        item.valorParcelaInicial =
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraItau ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraUne
                ?
                    item.valorParcelaInicialSemSeguroPrestamista +
                        (item.percSeguroPrestamista ? item.valorSeguroPrestamista *
                            (item.percRedutorParcela ? item.fatorRedutorParcela : 1) : 0)
                :
                    item.valorParcelaInicialSemSeguroPrestamista +
                        (item.percSeguroPrestamista ? item.valorSeguroPrestamista : 0)

        item.valorParcelasAdesao = ''

        //item.percLanceRecursosProprios =
        //    item.lanceRecursosProprios && item.valorCreditoConsorcio
        //        ?
        //            item.lanceRecursosProprios / item.valorCreditoConsorcio * 100
        //        :
        //            ''
        item.lanceRecursosProprios =
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
            //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander
                ?
                    item.valorSaldoDevedor && item.percLanceRecursosProprios
                        ?
                            item.valorSaldoDevedor * (item.percLanceRecursosProprios / 100)
                        :
                            ''
                :
                    item.valorCreditoConsorcio && item.percLanceRecursosProprios
                        ?
                            item.valorCreditoConsorcio * (item.percLanceRecursosProprios / 100)
                        :
                            ''

        //item.percLanceEmbutido =
        //    item.lanceEmbutido && item.valorCreditoConsorcio
        //        ?
        //            item.lanceEmbutido / item.valorCreditoConsorcio * 100
        //        :
        //            ''
        item.lanceEmbutido =
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
            //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander
                ?
                    item.valorSaldoDevedor && item.percLanceEmbutido
                        ?
                            item.valorSaldoDevedor * (item.percLanceEmbutido / 100)
                        :
                            ''
                :
                    item.valorCreditoConsorcio && item.percLanceEmbutido
                        ?
                            item.valorCreditoConsorcio * (item.percLanceEmbutido / 100)
                        :
                            ''
        
        item.valorLanceTotal = (item.lanceRecursosProprios ? round(item.lanceRecursosProprios, 2) : 0) +
            (item.lanceEmbutido ? round(item.lanceEmbutido, 2) : 0)

        item.percLancetotal =
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRacon ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraRodobens ||
            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraSantander
                ?
                    item.valorLanceTotal && item.valorSaldoDevedor
                        ?
                            item.valorLanceTotal / item.valorSaldoDevedor * 100
                        :
                            ''
                :
                    item.valorLanceTotal && item.valorCreditoConsorcio
                        ?
                            item.valorLanceTotal / item.valorCreditoConsorcio * 100
                        :
                            ''

        item.prazoRestanteAposContemplacao =
            item.prazoTotalGrupoConsorcio && item.contemplacaoParcela
                ?
                    item.prazoTotalGrupoConsorcio - item.contemplacaoParcela
                :
                    ''

        item.valorCreditoDisponivel = item.valorCreditoConsorcio - (item.lanceEmbutido ? item.lanceEmbutido : 0)

        item.valorSaldoDevedorAposContemplacao = item.valorSaldoDevedor - item.valorLanceTotal -
            (item.valorParcelaInicialSemSeguroPrestamista * item.contemplacaoParcela)

        item.valorParcelaAposComtemplacao =
            (item.valorSaldoDevedorAposContemplacao / item.prazoRestanteAposContemplacao) +
                (item.percSeguroPrestamista ? item.valorSeguroPrestamista : 0)

    } else {

        if (
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras ||
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco ||
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa
        ) {

            item.valorTaxaAdesao = round(item.valorCreditoConsorcio * item.taxaAdesao / 100, 2)

            item.valorTaxaAdministracao = round(item.valorCreditoConsorcio * item.taxaAdministracao / 100, 2)

            item.fatorRedutorParcela = item.percRedutorParcela ? 1 - (item.percRedutorParcela / 100) : ''

            item.valorFundoReserva =
                //////item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                //////    ?
                //////        round(item.valorCreditoConsorcio * (item.percRedutorParcela ? item.fatorRedutorParcela : 1) *
                //////            item.percFundoReserva / 100, 2)
                //////    :
                round(item.valorCreditoConsorcio * item.percFundoReserva / 100, 2)

            item.taxaTotal =
                (item.valorTaxaAdesao || item.valorTaxaAdesao === 0) &&
                item.taxaAdministracao &&
                (item.percFundoReserva || item.percFundoReserva === 0)
                    ?
                        item.taxaAdesao + item.taxaAdministracao + item.percFundoReserva
                    :
                        ''

            item.valorTaxaTotal = item.valorTaxaAdesao + item.valorTaxaAdministracao + item.valorFundoReserva

            item.valorSaldoDevedor = round(item.valorCreditoConsorcio, 2) +
                item.valorTaxaAdministracao + item.valorFundoReserva +
                    (
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                            ?
                                item.valorTaxaAdesao
                            :
                                0
                    )

            if (item.pessoaFisicaJuridica === HARDCODE.idPessoaJuridica) {

                item.percSeguroPrestamista = ''
            }
            item.valorSeguroPrestamista = /*round(*/item.valorSaldoDevedor * item.percSeguroPrestamista / 100/*, 2)*/

            //item.fatorRedutorParcela = item.percRedutorParcela ? 1 - (item.percRedutorParcela / 100) : '' // Movido para cima para usar no cálculo do fundo de reserva

            item.valorParcelaInicialSemSeguroPrestamista =
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                    ?
                        ((round(item.valorCreditoConsorcio, 2) * (item.percRedutorParcela ? item.fatorRedutorParcela : 1)) +
                            item.valorTaxaAdministracao + /*//////item.valorFundoReserva*/
                                round(item.valorCreditoConsorcio * (item.percRedutorParcela ? item.fatorRedutorParcela : 1) *
                                    item.percFundoReserva / 100, 2)/* + item.valorTaxaAdesao*/) / item.prazoTotalGrupoConsorcio
                    :
                        /*round(*/((item.valorSaldoDevedor - (
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                                    ?
                                        item.valorTaxaAdesao
                                    :
                                        0
                        )) /
                        (
                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras &&
                            item.prazoOriginalGrupoConsorcio
                                ?
                                    item.prazoOriginalGrupoConsorcio
                                :
                                    item.prazoTotalGrupoConsorcio
                        )
                        ) * (item.percRedutorParcela ? item.fatorRedutorParcela : 1)/*, 2)*/
            
            item.valorParcelaInicialSemSeguroPrestamistaSemRedutor =
                /*round(*/
                (item.valorSaldoDevedor /
                    (
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras &&
                        item.prazoOriginalGrupoConsorcio
                            ?
                                item.prazoOriginalGrupoConsorcio
                            :
                                item.prazoTotalGrupoConsorcio
                    )
                )/*, 2)*/

            item.valorParcelaInicial =
                item.valorParcelaInicialSemSeguroPrestamista +
                    (item.percSeguroPrestamista ? item.valorSeguroPrestamista : 0)
                    
            item.valorParcelaInicialSemRedutor =
                item.valorParcelaInicialSemSeguroPrestamistaSemRedutor +
                    (item.percSeguroPrestamista ? item.valorSeguroPrestamista : 0)

            item.valorEconomiaRedutorParcela = item.valorParcelaInicialSemRedutor - item.valorParcelaInicial

            item.valorPrimeirasParcelas =
                item.valorTaxaAdesao && item.parcelasAdesao &&
                item.administradoraConsorcio !== HARDCODE.idInstituicaoFinanceiraBradesco
                    ?
                        item.valorParcelaInicial + (item.valorTaxaAdesao / item.parcelasAdesao)
                    :
                        ''

            item.valorParcelasAdesao =
                item.valorPrimeirasParcelas
                    ?
                        item.valorPrimeirasParcelas - item.valorParcelaInicial
                    :
                        0

            //item.percLanceRecursosProprios =
            //    item.lanceRecursosProprios && item.valorSaldoDevedor
            //        ?
            //            item.lanceRecursosProprios / item.valorSaldoDevedor * 100
            //        :
            //            ''
            item.lanceRecursosProprios =
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro
                    ?
                        '' // calculo mais abaixo
                    :
                        (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                            ?
                                item.valorCreditoConsorcio
                            :
                                item.valorSaldoDevedor
                        ) && item.percLanceRecursosProprios
                            ?
                                (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                                    ?
                                        item.valorCreditoConsorcio
                                    :
                                        item.valorSaldoDevedor
                                )
                                *
                                (item.percLanceRecursosProprios / 100)
                                /
                                (
                                    item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco
                                        ?
                                            (item.taxaAdesao ? 1 + (item.taxaAdesao / 100) : 1)
                                        :
                                            1
                                )
                            :
                                ''

            //item.percLanceEmbutido =
            //    item.lanceEmbutido && item.valorSaldoDevedor
            //        ?
            //            item.lanceEmbutido / item.valorSaldoDevedor * 100
            //        :
            //            ''
            //item.lanceEmbutido =
            //    (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
            //        ?
            //            item.valorCreditoConsorcio
            //        :
            //            item.valorSaldoDevedor
            //    ) && item.percLanceEmbutido
            //        ?
            //            (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
            //                ?
            //                    item.valorCreditoConsorcio
            //                :
            //                    item.valorSaldoDevedor
            //            ) * (item.percLanceEmbutido / 100)
            //        :
            //            ''
            item.lanceEmbutido =
                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco
                    ?
                        ''
                    :
                        (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro/* ||
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa*/
                            ?
                                item.valorCreditoConsorcio
                            :
                                item.valorSaldoDevedor
                        ) && item.percLanceEmbutido
                            ?
                                (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro/* ||
                                item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa*/
                                    ?
                                        item.valorCreditoConsorcio
                                    :
                                        item.valorSaldoDevedor
                                ) * (item.percLanceEmbutido / 100)
                            :
                                ''

            if (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ) {

                item.lanceRecursosProprios =
                    item.percLanceRecursosProprios && item.valorSaldoDevedor
                        ?
                            (
                                (item.valorSaldoDevedor + (item.valorTaxaAdesao ? item.valorTaxaAdesao : 0)) *
                                    (
                                        item.percLanceRecursosProprios +
                                            (item.percLanceEmbutido ? item.percLanceEmbutido : 0)
                                    ) / 100
                            ) - (item.lanceEmbutido)
                        :
                            ''
            }
                        
            item.valorLanceTotal = (item.lanceRecursosProprios ? round(item.lanceRecursosProprios, 2) : 0) +
                (item.lanceEmbutido ? round(item.lanceEmbutido, 2) : 0)

            //item.percLancetotal =
            //    item.valorLanceTotal && item.valorSaldoDevedor
            //        ?
            //            item.valorLanceTotal / item.valorSaldoDevedor * 100
            //        :
            //            ''
            item.percLancetotal =
                item.valorLanceTotal &&
                    (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                        ?
                            item.valorCreditoConsorcio
                        :
                            item.valorSaldoDevedor
                    )
                        ?
                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBradesco
                            ?
                                item.percLanceRecursosProprios
                            :
                                item.valorLanceTotal /
                                    (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon
                                        ?
                                            item.valorCreditoConsorcio
                                        :
                                            item.valorSaldoDevedor +
                                                (
                                                    item.administradoraConsorcio ===
                                                        HARDCODE.idInstituicaoFinanceiraPortoSeguro
                                                            ?
                                                                item.valorTaxaAdesao
                                                            :
                                                                0
                                                )
                                    ) * 100
                        :
                            ''

            item.valorCreditoDisponivel = item.valorCreditoConsorcio - (item.lanceEmbutido ? item.lanceEmbutido : 0)

            item.valorSaldoDevedorAposContemplacao = item.valorSaldoDevedor -
                (
                    //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras
                    //    ?
                    //        item.lanceEmbutido
                    //    :
                            item.valorLanceTotal
                ) -
                    //(item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras &&
                    //item.tipoGrupoConsorcio === HARDCODE.idTipoGrupoConsorcioEmAndamento
                    //    ?
                    //        0
                    //    :
                            item.valorParcelaInicialSemSeguroPrestamista * item.contemplacaoParcela
                    //)

            item.valorParcelaTeoricaPJ =
                (item.valorSaldoDevedorAposContemplacao / (item.prazoTotalGrupoConsorcio - item.contemplacaoParcela))

            if (
                    item.valorParcelaTeoricaPJ < (item.valorParcelaInicialSemSeguroPrestamistaSemRedutor / 2) &&
                    (
                        //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon &&
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraPortoSeguro ||
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraServopa
                    )
            ) {

                item.valorParcelaAposComtemplacao = item.valorParcelaInicialSemSeguroPrestamistaSemRedutor / 2

            } else {

                if (
                        item.valorParcelaTeoricaPJ < (item.valorSaldoDevedor * 0.0050) &&
                        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon &&
                        item.prazoTotalGrupoConsorcio <= 180
                ) {

                    item.valorParcelaAposComtemplacao = item.valorSaldoDevedor * 0.0050

                } else {

                    if (
                            item.valorParcelaTeoricaPJ < (item.valorSaldoDevedor * 0.002565) &&
                            item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraEmbracon &&
                            item.prazoTotalGrupoConsorcio > 180
                    ) {

                        item.valorParcelaAposComtemplacao = item.valorSaldoDevedor * 0.002565

                    } else {

                        item.valorParcelaAposComtemplacao = item.valorParcelaTeoricaPJ
                    }
                }
            }

            item.prazoRestanteAposContemplacao =
                item.valorSaldoDevedorAposContemplacao
                    ?
                        round(item.valorSaldoDevedorAposContemplacao / item.valorParcelaAposComtemplacao, 0)
                    :
                        ''

            item.valorSeguroPrestamistaNovo = item.valorSaldoDevedorAposContemplacao * item.percSeguroPrestamista / 100
            
            item.valorParcelaAposComtemplacao += (item.percSeguroPrestamista ? item.valorSeguroPrestamistaNovo : 0)

            if (item.valorLanceTotal === 0) {

                item.prazoRestanteAposContemplacaoReducaoPrazo = item.valorSaldoDevedorAposContemplacao ? LABEL.naoSeAplica : ''

                item.parcelaAposComtemplacaoReducaoPrazo = item.valorSaldoDevedorAposContemplacao ? LABEL.naoSeAplica : ''

            } else {

                if (item.valorSaldoDevedorAposContemplacao) {

                    item.prazoRestanteAposContemplacaoReducaoPrazo =
                        item.valorSaldoDevedorAposContemplacao / item.valorParcelaInicialSemSeguroPrestamistaSemRedutor

                    item.parcelaAposComtemplacaoReducaoPrazo =
                        (item.valorSaldoDevedorAposContemplacao / item.prazoRestanteAposContemplacaoReducaoPrazo) +
                            (item.percSeguroPrestamista ? item.valorSeguroPrestamistaNovo : 0)
                    
                    item.prazoRestanteAposContemplacaoReducaoPrazo = round(item.prazoRestanteAposContemplacaoReducaoPrazo, 0)

                } else {

                    item.prazoRestanteAposContemplacaoReducaoPrazo = ''

                    item.parcelaAposComtemplacaoReducaoPrazo = ''
                }
            }

        } else {

            if (item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraMAPFRE) {

                if (!item.tipoLance) {

                    item.tipoLance = linhaInstituicaoFinanceira.tipoLanceList[0].id
                }

                if (!item.formaAbaterLance) {

                    item.formaAbaterLance = HARDCODE.idFormaAbaterLanceReduzirParcela
                }

                item.percValorUpGradeCreditoConsorcio =
                    item.valorUpGradeCreditoConsorcio && item.valorCreditoConsorcio
                        ?
                            item.valorUpGradeCreditoConsorcio / item.valorCreditoConsorcio * 100
                        :
                            ''
            
                item.valorCreditoConsorcioMaisUpGradeSemSeguroPrestamista =
                    round(item.valorCreditoConsorcio, 2) +
                        (item.valorUpGradeCreditoConsorcio ? round(item.valorUpGradeCreditoConsorcio, 2) : 0)

                item.valorUpGradeCreditoConsorcioTaxaAdministracao =
                    item.valorUpGradeCreditoConsorcio
                        ?
                            round(item.valorUpGradeCreditoConsorcio * item.taxaAdministracao / 100, 2)
                        :
                            0

                item.valorUpGradeCreditoConsorcioFundoReserva =
                    item.valorUpGradeCreditoConsorcio
                        ?
                            round(item.valorUpGradeCreditoConsorcio * item.percFundoReserva / 100, 2)
                        :
                            0

                item.valorUpGradeCreditoConsorcioSaldoDevedor =
                    item.valorUpGradeCreditoConsorcio
                        ?
                            round(item.valorUpGradeCreditoConsorcio, 2) + item.valorUpGradeCreditoConsorcioTaxaAdministracao +
                                item.valorUpGradeCreditoConsorcioFundoReserva
                        :
                            0

                item.valorTaxaAdministracao = round(item.valorCreditoConsorcio * item.taxaAdministracao / 100, 2)

                item.valorFundoReserva = round(item.valorCreditoConsorcio * item.percFundoReserva / 100, 2)

                item.taxaTotal =
                    item.taxaAdministracao && (item.percFundoReserva || item.percFundoReserva === 0)
                        ?
                            item.taxaAdministracao + item.percFundoReserva
                        :
                            ''

                item.valorTaxaTotal = item.valorTaxaAdministracao + item.valorFundoReserva

                item.valorSaldoDevedor =
                    round(item.valorCreditoConsorcio, 2) + item.valorTaxaAdministracao + item.valorFundoReserva

                if (item.pessoaFisicaJuridica === HARDCODE.idPessoaJuridica) {

                    item.percSeguroPrestamista = ''
                }
                item.valorSeguroPrestamista = round(item.valorCreditoConsorcio * item.percSeguroPrestamista / 100, 2)

                item.valorParcelaInicialSemSeguroPrestamista =
                    /*round(*/item.valorSaldoDevedor / item.prazoTotalGrupoConsorcio/*, 2)*/

                item.valorParcelaInicial =
                    item.valorParcelaInicialSemSeguroPrestamista + (item.percSeguroPrestamista ? item.valorSeguroPrestamista : 0)

                item.valorSeguroPrestamistaCreditoConsorcioMaisUpGrade =
                    /*round(*/item.valorCreditoConsorcioMaisUpGradeSemSeguroPrestamista * item.percSeguroPrestamista / 100/*, 2)*/

                item.valorParcelasAdesao = ''

                //item.percLanceRecursosProprios =
                //    item.lanceRecursosProprios && item.valorCreditoConsorcio
                //        ?
                //            item.lanceRecursosProprios / item.valorCreditoConsorcio * 100
                //        :
                //            ''
                item.lanceRecursosProprios =
                    item.valorCreditoConsorcio && item.percLanceRecursosProprios
                        ?
                            item.valorCreditoConsorcio * (item.percLanceRecursosProprios / 100)
                        :
                            ''

                //item.percLanceIntegrado =
                //    item.lanceIntegrado && item.valorCreditoConsorcio
                //        ?
                //            item.lanceIntegrado / item.valorCreditoConsorcio * 100
                //        :
                //            ''
                item.lanceIntegrado =
                    item.valorCreditoConsorcio && item.percLanceIntegrado
                        ?
                            item.valorCreditoConsorcio * (item.percLanceIntegrado / 100)
                        :
                            ''

                //item.percTipoLanceValor =
                //    item.tipoLanceValor && item.valorCreditoConsorcio
                //        ?
                //            item.tipoLanceValor / item.valorCreditoConsorcio * 100
                //        :
                //            ''
                item.tipoLanceValor =
                    item.valorCreditoConsorcio && item.percTipoLanceValor
                        ?
                            item.valorCreditoConsorcio * (item.percTipoLanceValor / 100)
                        :
                            ''
        
                item.valorLanceTotal = (item.lanceRecursosProprios ? round(item.lanceRecursosProprios, 2) : 0) +
                    (item.lanceIntegrado ? round(item.lanceIntegrado, 2) : 0) +
                        (item.tipoLanceValor ? round(item.tipoLanceValor, 2) : 0)

                item.percLancetotal =
                    item.valorLanceTotal && item.valorCreditoConsorcio
                        ?
                            item.valorLanceTotal / item.valorCreditoConsorcio * 100
                        :
                            ''

                item.valorCreditoDisponivel = item.valorCreditoConsorcioMaisUpGradeSemSeguroPrestamista -
                    (item.lanceIntegrado ? item.lanceIntegrado : 0) - (item.tipoLanceValor ? item.tipoLanceValor : 0)

                item.valorTCV =
                    item.valorParcelaInicialSemSeguroPrestamista && item.parcelasTCV
                        ?
                            item.valorParcelaInicialSemSeguroPrestamista * item.parcelasTCV
                        :
                            0

                item.valorLanceTotalMenosTCV =
                    item.valorLanceTotal - (item.valorTCV ? item.valorTCV : 0)

                item.percLanceSobreCredito = 
                    item.lanceRecursosProprios && item.valorCreditoConsorcio
                        ?
                            item.lanceRecursosProprios / item.valorCreditoConsorcio * 100
                        :
                            ''

                item.percLanceEfetivo =
                    item.lanceRecursosProprios && item.valorCreditoDisponivel
                        ?
                            item.lanceRecursosProprios / item.valorCreditoDisponivel * 100
                        :
                            ''

                if (item.formaAbaterLance === HARDCODE.idFormaAbaterLanceReduzirParcela) {

                    item.prazoRestanteAposContemplacao =
                        item.prazoTotalGrupoConsorcio && item.contemplacaoParcela
                            ?
                                round(item.prazoTotalGrupoConsorcio - item.contemplacaoParcela -
                                    (item.parcelasTCV ? item.parcelasTCV : 0), 0)
                            :
                                ''

                    item.valorParcelaAposComtemplacao =
                        (item.valorParcelaInicialSemSeguroPrestamista +
                            (item.valorUpGradeCreditoConsorcioSaldoDevedor - item.valorLanceTotalMenosTCV) /
                            item.prazoRestanteAposContemplacao) + item.valorSeguroPrestamistaCreditoConsorcioMaisUpGrade

                } else {

                    if (item.valorLanceTotalMenosTCV < 0) {

                        item.prazoRestanteAposContemplacao =
                            item.prazoTotalGrupoConsorcio && item.contemplacaoParcela &&
                            item.valorParcelaInicialSemSeguroPrestamista
                                ?
                                    round((item.prazoTotalGrupoConsorcio - item.contemplacaoParcela) -
                                        (item.valorLanceTotal / item.valorParcelaInicialSemSeguroPrestamista) -
                                            ((item.valorLanceTotalMenosTCV * -1) /
                                                item.valorParcelaInicialSemSeguroPrestamista), 0)
                                :
                                    ''

                        item.valorParcelaAposComtemplacao =
                            item.valorParcelaInicialSemSeguroPrestamista +
                                (item.valorUpGradeCreditoConsorcioSaldoDevedor / item.prazoRestanteAposContemplacao) +
                                item.valorSeguroPrestamistaCreditoConsorcioMaisUpGrade +
                                ((item.valorLanceTotalMenosTCV * -1) / item.prazoRestanteAposContemplacao)
                    
                    } else {

                        item.prazoRestanteAposContemplacao =
                            item.prazoTotalGrupoConsorcio && item.contemplacaoParcela &&
                            item.valorParcelaInicialSemSeguroPrestamista
                                ?
                                    round((item.prazoTotalGrupoConsorcio - item.contemplacaoParcela) -
                                        (item.valorLanceTotal / item.valorParcelaInicialSemSeguroPrestamista), 0)
                                :
                                    ''

                        item.valorParcelaAposComtemplacao = item.valorParcelaInicialSemSeguroPrestamista + 
                            (item.valorUpGradeCreditoConsorcioSaldoDevedor / item.prazoRestanteAposContemplacao)
                                + item.valorSeguroPrestamistaCreditoConsorcioMaisUpGrade
                    }
                }
                
                item.valorSaldoDevedorAposContemplacao =
                    round(item.valorParcelaAposComtemplacao * item.prazoRestanteAposContemplacao, 2)
            }
        }
    }

    item.valorTotalPagar =
        //item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras &&
        //item.tipoGrupoConsorcio === HARDCODE.idTipoGrupoConsorcioEmAndamento
        //    ?
        //        0
        //    :
                item.valorParcelaInicial * item.contemplacaoParcela

    if (item.lanceRecursosProprios) {

        item.valorTotalPagar += item.lanceRecursosProprios
    }

    item.valorTotalPagar += item.valorParcelaAposComtemplacao * item.prazoRestanteAposContemplacao

    if (item.valorParcelasAdesao) {

        item.valorTotalPagar += item.valorParcelasAdesao * item.parcelasAdesao
    }

    item.valorCreditoConsorcioContemplacao = ''
    item.taxaAnualReajusteConsorcio = ''

    if (item.valorCreditoDisponivel && item.idFinanciamento) {

        const linhaFinanciamento = pesquisaList(values.financiamento, item.idFinanciamento)

        if (linhaFinanciamento.mesAnoPrimeiroReajuste && linhaFinanciamento.taxaAnual) {
            //console.log('--------------')
            //console.log(item.contemplacaoParcela)
            //console.log(values.dataSimulacaoEstudo)
            //console.log(linhaFinanciamento.mesAnoPrimeiroReajuste)

            let prazo = item.contemplacaoParcela -
                calculaMeses(formataDataEmMesAnoSemBarra(values.dataSimulacaoEstudo), linhaFinanciamento.mesAnoPrimeiroReajuste) + 1

            //console.log(prazo)
            if (prazo > 0) {

                prazo = Math.trunc(prazo / 12) + (prazo % 12 > 0 ? 1 : 0)
                //console.log(prazo)

                item.valorCreditoConsorcioContemplacao = round(item.valorCreditoDisponivel *
                    Math.pow(1 + (linhaFinanciamento.taxaAnual / 100), prazo), 2)

                item.taxaAnualReajusteConsorcio = linhaFinanciamento.taxaAnual
                //console.log(item.valorCreditoConsorcioContemplacao)
            } else {

                item.valorCreditoConsorcioContemplacao = item.valorCreditoDisponivel
            }
        }
    }


    //console.log('----------------')
    //console.log(item.valorTotalPagar)
    //console.log(((item.valorTotalPagar - item.valorCreditoDisponivel) / item.valorCreditoDisponivel * 100) / item.prazoTotalGrupoConsorcio)
    //console.log(item.valorCreditoDisponivel)
    //console.log((((item.valorTotalPagar - item.valorCreditoDisponivel) / item.valorCreditoDisponivel * 100) / item.prazoTotalGrupoConsorcio) * 12)

    item.taxaAdministracaoReal = item.valorTaxaAdministracao / item.valorCreditoDisponivel * 100
    item.percFundoReservaReal = item.valorFundoReserva / item.valorCreditoDisponivel * 100
    item.taxaTotalReal = item.valorTaxaTotal / item.valorCreditoDisponivel * 100
    item.taxaEfetivaMensalReal = item.taxaTotalReal / item.prazoTotalGrupoConsorcio
    item.taxaEfetivaAnualReal = round(item.taxaEfetivaMensalReal * 12, 2)
    item.taxaEfetivaMensal = round(item.taxaEfetivaMensalReal , 2)

    item.taxaEfetivaMensal = item.taxaTotal / item.prazoTotalGrupoConsorcio
    //item.taxaEfetivaMensal = ((item.valorTotalPagar - item.valorCreditoDisponivel) / item.valorCreditoDisponivel * 100) / item.prazoTotalGrupoConsorcio
    //item.taxaEfetivaMensal = (item.valorTaxaTotal / item.valorCreditoDisponivel * 100) / item.prazoTotalGrupoConsorcio
    item.taxaEfetivaAnual = round(item.taxaEfetivaMensal * 12, 2)
    item.taxaEfetivaMensal = round(item.taxaEfetivaMensal , 2)

    if (
            item.idFinanciamento &&
            //pesquisaList(values.financiamento, item.idFinanciamento).taxaAnual && // foi retirado pois estava fazendo com que a alteraçao da taxa anual não fosse atualizada
            !values.naoIncluirAtualizarFinanciamento
    ) {

        incluirAtualizarFinanciamento(values, item)
    }
}



export const incluirAtualizarFinanciamento = (values, item) => {
    
    if (!item.idFinanciamento || !pesquisaList(values.financiamento, item.idFinanciamento).id) {

        if (!values.financiamento) {
            
            processaRegistrosDefaultIniciaisFinanciamento(values, HARDCODE.idFamiliarCliente)
        }

        incrementaContFinanciamento(values)

        values.financiamento.push({
            id: values.contFinanciamento,
            familiar: HARDCODE.idFamiliarCliente
            
        })

        item.idFinanciamento = values.contFinanciamento
    }

    const ind = pesquisaIndexList(values.financiamento, item.idFinanciamento)

    values.financiamento[ind].tipoFinanciamento = HARDCODE.idTipoFinanciamentoImovel
    values.financiamento[ind].consorcio = true
    values.financiamento[ind].tabelaSAC = false
    values.financiamento[ind].valorParcela = item.valorParcelaInicial
    values.financiamento[ind].qtdeParcelas = item.contemplacaoParcela
    values.financiamento[ind].mesAnoPrimeiroReajuste = item.mesAnoPrimeiroReajuste
    values.financiamento[ind].taxaAnual = item.taxaAnual
    values.financiamento[ind].possuiParcelasAdicionais = true

    const parcelasAdicionaisAnt =
        values.financiamento[ind].parcelasAdicionais
            ?
                [...values.financiamento[ind].parcelasAdicionais]
            :
                []

    values.financiamento[ind].parcelasAdicionais = []

    if (item.lanceRecursosProprios) {

        values.financiamento[ind].parcelasAdicionais.push(
            calculaParcelaAdicional(values, item.contemplacaoParcela, item.contemplacaoParcela,
                item.lanceRecursosProprios, LABEL.lanceRecursosProprios, values.financiamento[ind].mesAnoInicial)
        )
    }

    //if (
    //        item.administradoraConsorcio === HARDCODE.idInstituicaoFinanceiraBancorbras &&
    //        item.tipoGrupoConsorcio === HARDCODE.idTipoGrupoConsorcioEmAndamento
    //) {

    //    values.financiamento[ind].valorParcela = item.valorParcelaAposComtemplacao
    //    values.financiamento[ind].qtdeParcelas = item.prazoRestanteAposContemplacao

    //    if (!item.lanceRecursosProprios && !item.valorParcelasAdesao) {
        
    //        values.financiamento[ind].possuiParcelasAdicionais = false
    //    }

    //} else {

        values.financiamento[ind].parcelasAdicionais.push(
            calculaParcelaAdicional(values, item.contemplacaoParcela + 1, item.prazoRestanteAposContemplacao,
                item.valorParcelaAposComtemplacao, LABEL.parcelaAposComtemplacao, values.financiamento[ind].mesAnoInicial)
        )
    //}

    if (item.valorParcelasAdesao) {

        values.financiamento[ind].parcelasAdicionais.push(
            calculaParcelaAdicional(values, 1, item.parcelasAdesao,
                item.valorParcelasAdesao, LABEL.adesao, values.financiamento[ind].mesAnoInicial)
        )
    }

    if (item.fundoReservaSeraDevolvidoFinal && item.mesesDevolucaoFundoReserva) {

        values.financiamento[ind].parcelasAdicionais.push(
            calculaParcelaAdicional(values,
                item.contemplacaoParcela + item.prazoRestanteAposContemplacao + item.mesesDevolucaoFundoReserva,
                    item.contemplacaoParcela + item.prazoRestanteAposContemplacao + item.mesesDevolucaoFundoReserva,
                        item.valorFundoReserva * -1 *
                            (item.percDevolucaoFundoReserva ? (item.percDevolucaoFundoReserva / 100) : 1),
                                LABEL.devolucaoFundoReserva, values.financiamento[ind].mesAnoInicial)
        )
    }

    parcelasAdicionaisAnt?.forEach( (linhaAnt, indAnt) => {

        if (!linhaAnt.automatica) {
            
            values.financiamento[ind].parcelasAdicionais.push(linhaAnt)
        }
    })

    values.financiamento[ind].consorcioGerado = true
    values.financiamento[ind].instituicao =
        item.naoExibirLogo
            ?
                ''
            :
                pesquisaDescricaoList(instituicaoFinanceiraList, item.administradoraConsorcio)
    values.financiamento[ind].valorCreditoConsorcio = item.valorCreditoConsorcio
    values.financiamento[ind].prazoTotalGrupoConsorcio = item.prazoTotalGrupoConsorcio
    values.financiamento[ind].taxaAdministracao = item.taxaAdministracao
    values.financiamento[ind].percFundoReserva = item.percFundoReserva
    values.financiamento[ind].percRedutorParcela = item.percRedutorParcela
    values.financiamento[ind].percSeguroPrestamista = item.percSeguroPrestamista
    // analisarAluguelAposContemplacao
    // mesesIniciarAluguelAposContemplacao
    // percAluguelMensalAposContemplacao
    ////values.financiamento[ind].valorCreditoDisponivel = item.valorCreditoDisponivel
    values.financiamento[ind].valorCreditoConsorcioContemplacao = item.valorCreditoConsorcioContemplacao
    

    if (
            item.analisarAluguelAposContemplacao &&
            item.mesesIniciarAluguelAposContemplacao >= 0 &&
            item.percAluguelMensalAposContemplacao > 0 &&
            item.percReajusteAluguelAnualAposContemplacao > 0
    ) {
    
        values.financiamento[ind].mesAnoInicialAluguelAposContemplacao = 
            calculaParcelaAdicional(values,
                item.contemplacaoParcela + item.mesesIniciarAluguelAposContemplacao,
                    item.contemplacaoParcela + item.mesesIniciarAluguelAposContemplacao, 0, '', '').mesAnoInicial
        values.financiamento[ind].percAluguelMensalAposContemplacao = item.percAluguelMensalAposContemplacao
        values.financiamento[ind].percReajusteAluguelAnualAposContemplacao =
            item.percReajusteAluguelAnualAposContemplacao
        values.financiamento[ind].percValorizacaoImovelAluguelAposContemplacao = item.percValorizacaoImovelAluguelAposContemplacao
        values.financiamento[ind].valorAluguelAposContemplacao =
            round(
                (item.valorImovelAluguelAposContemplacao
                    ?
                        item.valorImovelAluguelAposContemplacao
                    :
                        item.valorCreditoConsorcioContemplacao//item.valorCreditoDisponivel
                ) * (item.percAluguelMensalAposContemplacao / 100), 2)
        values.financiamento[ind].mesAnoVendaAposQuitacao =
            item.analisarVendaAposQuitacao && item.mesesVendaAposQuitacao
                ?
                    calculaParcelaAdicional(values,
                        item.prazoTotalGrupoConsorcio + item.mesesVendaAposQuitacao,
                            item.prazoTotalGrupoConsorcio + item.mesesVendaAposQuitacao, 0, '', '').mesAnoInicial
                :
                    ''

    } else {

        values.financiamento[ind].mesAnoInicialAluguelAposContemplacao = ''
        values.financiamento[ind].percAluguelMensalAposContemplacao = ''
        values.financiamento[ind].percReajusteAluguelAnualAposContemplacao = ''
        values.financiamento[ind].percValorizacaoImovelAluguelAposContemplacao = ''
        values.financiamento[ind].valorAluguelAposContemplacao = ''
        values.financiamento[ind].mesAnoVendaAposQuitacao = ''
    }

    return ind
}